'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Resets scroll to top on every route change.
 * This prevents scroll position from persisting across different pages/modals.
 */
const ScrollReset = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Ensure browser manages scroll normally
    if (window.history?.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
    // Jump to top on navigation
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollReset;
